import { BusinessService } from './services/business.service';
import { CustomCurrencyPipe } from '../utilities/pipes/custom-currency.pipe';
import { MoneyHelper } from './helpers/money.helper';
import { AuthGuard } from './services/auth-guard.service';
import { AuthorizedUser } from './services/authorized-user.service';
import { AuthenticationService } from './services/authentication.service';
import { LocalStorageService } from './services/local-storage.service';
import { DeviceIdHandlerComponent } from './helpers/device-id-handler.component';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { ApiClientHelper } from './helpers/api-client.helper';
import { BrowserHelper } from './helpers/browser.helper';
import { LocationHelper } from './helpers/location.helper';
import { AccountService } from './services/account-service';
import { UserAuthorityService } from './services/user-authority.service';
import { CustomModalService } from './services/custom-modal-service';
import { RegistrationService } from './services/registration-service';
import { CurrencyHelperService } from './helpers/currency-helper.service';
import { OutletService } from './services/outlet-service';
import { CardService } from './services/card-service';
import { InsuranceService } from './services/insurance-service';
import { OfflineService } from './services/Offline-service';
import { BreakDownDetailsService } from './services/break-down-details-services';
import { PndService } from './services/pnd.service';
import { FormValidationService } from './services/form-validation-service';
import { TransferService } from './services/transfer.service';
import { LogisticsService } from './services/logistics.service';
import { BRMDeliveryService } from './services/brmdelivery.service';
import { WclService } from './wcl/services/wcl-service.service';
import { CurrencyOrStringPipe } from './pipes/currency-or-string.pipe';
import { SeparateStringOnCasePipe } from './pipes/separate-string-on-case.pipe';
import { SeparateStringOnCaseRemoveFirstPartPipe } from './pipes/separate-string-on-case-remove-first-part.pipe';
import { DeliveryService } from './services/delivery.service';
import { OrdinalDatePipe } from './pipes/ordinal-date.pipe';
import { SentenceCasePipe } from './pipes/sentence-case.pipe';
import { ExpiresInPipe } from './pipes/expires-in.pipe';
import { PluralizeUnitPipe } from './pipes/pluralize-unit.pipe';
import { OnboardingGuard } from '../core/services/onboarding-guard.service';

@NgModule({
	declarations: [
		DeviceIdHandlerComponent,
		CurrencyOrStringPipe,
		SeparateStringOnCasePipe,
		SeparateStringOnCaseRemoveFirstPartPipe,
		OrdinalDatePipe,
		SentenceCasePipe,
		ExpiresInPipe,
		PluralizeUnitPipe,
	],
	imports: [CommonModule, HttpClientModule],
	exports: [
		DeviceIdHandlerComponent,
		CurrencyOrStringPipe,
		SeparateStringOnCasePipe,
		SeparateStringOnCaseRemoveFirstPartPipe,
		OrdinalDatePipe,
		SentenceCasePipe,
		ExpiresInPipe,
		PluralizeUnitPipe,
	],
	providers: [
		CookieService,
		LocalStorageService,
		AuthenticationService,
		RegistrationService,
		AccountService,
		ApiClientHelper,
		BrowserHelper,
		LocationHelper,
		AuthorizedUser,
		UserAuthorityService,
		AuthGuard,
		CustomModalService,
		MoneyHelper,
		CurrencyHelperService,
		OutletService,
		CustomCurrencyPipe,
		CardService,
		InsuranceService,
		OfflineService,
		BreakDownDetailsService,
		PndService,
		BusinessService,
		FormValidationService,
		TransferService,
		LogisticsService,
		BRMDeliveryService,
		WclService,
		DeliveryService,
    OnboardingGuard
	],
})
export class CoreModule {}
